import React, { useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { userLogout1 } from '../../reducers/userInfo1';
import { Config } from '../../common/config';
import { translations } from '../../data/translation';

export default function UserConfirm(props) {
  const userInfo1 = useSelector(state => state.userInfo1);
  const language = useSelector(state => state.language.language);
  const t = translations[language];

  const goLogin = () => {
    const adminId = userInfo1?.id || '';
    userLogout1();
    const url = adminId
      ? `${Config.SHOPADMIN_SERVER}login?adminId=${encodeURIComponent(adminId)}`
      : `${Config.SHOPADMIN_SERVER}login`;
    window.location.href = url;
  };

  useEffect(() => {}, []);

  return (
    <>
      <section className="location_box">
        <ul className="location_001">
          <li>{t.home}</li>
          <li>{t.signupComplete}</li>
        </ul>
      </section>

      <main>
        <section className="contants_box_04">
          <article className="signup_07">
            <h2 className="tit_01">{t.signupComplete}</h2>
            <p>{t.signupCongrats}</p>
          </article>

          <article className="contants_box_03">
            <div className="signup_07_001">
              {t.signupThanksName.replace('{name}', userInfo1?.name || '')}
              <br />
              {language === 'ko' ? userInfo1?.name : ''}{t.signupIdIs}{' '}
              <span className="font_red">&nbsp;{userInfo1?.id}&nbsp;</span>
              {t.signupIdEnd}
              <br />
              {t.signupIdNoticeFull}
              <br />
              {t.signupPromise}
            </div>
          </article>

          <article className="button_box_01">
            <NavLink to="/">
              <button
                type="button"
                className="button_01 button_03 button_gray_line"
              >
                {t.home}
              </button>
            </NavLink>
            <button
              type="button"
              className="button_01 button_03 button_red"
              onClick={goLogin}
            >
              {t.login}
            </button>
          </article>
        </section>
      </main>
    </>
  );
}
